import type { ScatterplotComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const scatterplotDuplicate: DuplicationHandler<ScatterplotComponentSpec> = (spec) => {
  if (spec.xAxis) spec.xAxis.queryId = crypto.randomUUID();
  spec.yAxis.queryId = crypto.randomUUID();
};
